import { render, staticRenderFns } from "./MyTitle.vue?vue&type=template&id=5f8cd41e&scoped=true"
import script from "./MyTitle.vue?vue&type=script&lang=js"
export * from "./MyTitle.vue?vue&type=script&lang=js"
import style0 from "./MyTitle.vue?vue&type=style&index=0&id=5f8cd41e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cd41e",
  null
  
)

export default component.exports